import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormCertificate } from './list/types';

export const initialValues: FiltersFormCertificate = {
  orders: {},
  dateFrom: null,
  dateTo: null,
  acronym: undefined,
  year: undefined,
  progressive: undefined,
  page: 0,
  rowsPerPage: 10,
  fiscalCode: '',
  name: '',
  surname: '',
};

const PageCertificateInitializer = (): ReactElement => {
  const { userProfile } = useUserProfile();

  return (
    <FilterTableProvider
      initialValues={{
        ...initialValues,
        service:
          userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '0' ||
          userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '1'
            ? userProfile.datiLogin?.profile?.servizio?.key?.codiceServizio
            : undefined,
        serviceDesc:
          userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '0' ||
          userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '1'
            ? userProfile.datiLogin?.profile?.servizio?.descrizione
            : undefined,
        operator:
          userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '0'
            ? userProfile.datiLogin?.key?.userName
            : undefined,
        operatorDesc:
          userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '0'
            ? userProfile.datiLogin?.nome
            : undefined,
      }}
    >
      <Outlet />
    </FilterTableProvider>
  );
};

PageCertificateInitializer.displayName = 'Page certificate initializer component';

export default PageCertificateInitializer;
